import React, { Component } from 'react';

import { Form } from 'react-bootstrap';
import { window } from 'browser-monads'

class AutoScrollOption extends Component {
    constructor(props) {
        super(props);

        this.localStorageVarName = 'shouldAutoScroll'

        this.state = {
            shouldAutoScroll: this.getStateFromLocalStorage()
        };

    }

    updateLocalStorage = (shouldAutoScroll) => {
        if(window) {
            window.localStorage.setItem(this.localStorageVarName, shouldAutoScroll)
        }
    }

    getStateFromLocalStorage = () => {
        if(window) {
            let shouldAutoScroll = window.localStorage.getItem(this.localStorageVarName)

            if(shouldAutoScroll === null || shouldAutoScroll === undefined) {
                console.log('I am here')
                return true
            } else {
                return (shouldAutoScroll.toLowerCase() === 'true')
            }
        } else {
            return shouldAutoScroll
        }
    }

    handleToggle = () => {
        let nextShouldAutoScroll = !this.state.shouldAutoScroll
        
        this.setState({shouldAutoScroll: nextShouldAutoScroll}, () => {
            this.updateLocalStorage(nextShouldAutoScroll)
        })
    }

    shouldAutoScroll = () => {
        return this.state.shouldAutoScroll
    }

    render() {
        return (
            <Form.Check 
                id='autoScrollCheckbox'
                type='checkbox'
                label='Use auto scroll after analysis'
                onChange={this.handleToggle}
                checked = {this.state.shouldAutoScroll}
                className='mt-3'
            />
        )
    }
}

export default AutoScrollOption;

